import { render, staticRenderFns } from "./PigmentForm.vue?vue&type=template&id=0a50dce2&scoped=true"
import script from "./PigmentForm.vue?vue&type=script&lang=js"
export * from "./PigmentForm.vue?vue&type=script&lang=js"
import style0 from "./PigmentForm.vue?vue&type=style&index=0&id=0a50dce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50dce2",
  null
  
)

export default component.exports